import { BROADCAST_STATE_CODE } from 'core/ga/enums'

const {
  ACCEPTED,
  CANCEL,
  CONVERTING,
  ERROR,
  ON_AIR,
  READY,
  REHEARSAL,
  REHEARSAL_ON_AIR,
  SIGN_OFF,
  STAND_BY,
  SWITCHING,
  VOD,
  WARNING,
} = BROADCAST_STATE_CODE

const getBroadcastStatus = (broadcastStateCode: BroadcastStateCode) => {
  const isAccepted = broadcastStateCode === ACCEPTED
  const isCancel = broadcastStateCode === CANCEL
  const isConverting = broadcastStateCode === CONVERTING
  const isError = broadcastStateCode === ERROR
  const isLive = broadcastStateCode === ON_AIR
  const isReady = broadcastStateCode === READY
  const isRehearsal = broadcastStateCode === REHEARSAL
  const isRehearsalOnAir = broadcastStateCode === REHEARSAL_ON_AIR
  const isRejected = broadcastStateCode === null
  const isSignOff = broadcastStateCode === SIGN_OFF
  const isStandby = broadcastStateCode === STAND_BY
  const isSwitching = broadcastStateCode === SWITCHING
  const isVod = broadcastStateCode === VOD
  const isWarning = broadcastStateCode === WARNING

  const isBeforeBroadcast = isAccepted || isReady || isStandby
  const isBroadcastEnd = isCancel || isRejected || isVod
  const isOnAir = isLive || isWarning
  const isRewardOnAir = isLive || isWarning || isError

  return {
    isAccepted,
    isCancel,
    isConverting,
    isError,
    isLive,
    isReady,
    isRehearsal,
    isRehearsalOnAir,
    isRejected,
    isSignOff,
    isStandby,
    isSwitching,
    isVod,
    isWarning,
    isBeforeBroadcast,
    isBroadcastEnd,
    isOnAir,
    isRewardOnAir,
  }
}

export default getBroadcastStatus
